import Header from "@/components/Header";
import Hero from "@/components/Hero";
import { LazyLoadHomeGenerator, LazyLoadHomeGallery, LazyLoadPricing, LazyLoadComingSoon } from "@/components/LazyComponents";
import LazyHomeThemes from "@/components/LazyHomeThemes";
import HomeBlog from "@/components/HomeBlog";
import Footer from "@/components/Footer";
import FloatingParticles from "@/components/FloatingParticles";
import SEO from "@/components/SEO";
import { OrganizationSchema, WebsiteSchema } from "@/components/StructuredData";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Index = () => {
  const location = useLocation();

  // Handle scroll to pricing section when navigated from credit top-up
  useEffect(() => {
    if (location.state?.scrollToPricing) {
      const timer = setTimeout(() => {
        const pricingElement = document.getElementById('pricing');
        if (pricingElement) {
          pricingElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100); // Small delay to ensure components are loaded
      
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  return (
    <div className="min-h-screen bg-background relative">
      <SEO />
      <OrganizationSchema />
      <WebsiteSchema />
      <FloatingParticles />
      <div className="relative z-10">
        <Header />
      <Hero />
      <div id="generator">
        <LazyLoadHomeGenerator />
      </div>
      <div id="gallery">
        <LazyLoadHomeGallery />
      </div>
      <div id="blog">
        <HomeBlog />
      </div>
      <div id="themes">
        <LazyHomeThemes />
      </div>
        <LazyLoadComingSoon />
        <LazyLoadPricing />
        <Footer />
      </div>
    </div>
  );
};

export default Index;
